import { get, post } from '@/utils/config/axios.config.js' //请求配置
console.log(this, 'this')
export const info = params => get('/auth/app/login', params)

export const loginToken = data => post('/auth/app/login', data)
export const getMenuList = params => get('/system/web/index/list', params)

export const tableInfo = params => get('/system/web/contest/list', params)

export const auditStatusPost = data => post('/system/web/contest/auditStatus', data)

export const contestListDown = params => get('/system/web/contest/contestListDown', params)
export const tournamentInfo = params => get('/system/web/tournament/list', params)

export const tournamentStatusPost = data => post('/system/web/tournament/edit', data)
export const livePlayList = params => get('/system/web/live/playback/even/list', params)

export const tournamentGet = params => get('/system/web/tournament/' + params.id, params)

export const bannerList = params => get('/system/web/banner/list', params)
export const contestConfigDataList = params => get('/system/web/banner/contestConfigDataList', params)

export const delBanner = params => post(`/system/web/banner/delete/${params}`)

export const contestBindingNew = params => post('/system/web/contestBinding/contestBindingNew', params)
export const uploadPhoto = params => post('/system/web/oss/upload', params)
export const getContestBindingList = params => post('/system/web/contestBinding/getContestBindingList', params)
export const addContestBindingGroup = params => post('/system/web/contestBinding/addContestBindingGroup', params)
export const deleteContestBindingGroup = params => post('/system/web/contestBinding/deleteContestBindingGroup', params)
export const getContestBindingGroupList = params => post('/system/web/contestBinding/getContestBindingGroupList', params)
export const movePlayer = params => post('/system/web/basketballPlayer/movePlayer', params)

export const addBanner = params => post('/system/web/banner/save', params)

export const getBannerPhoto = params => get(`/system/web/oss/preview/${params}`)

export const uploadPhotos = params => post(`/system/web/contest/saveImg`, params)
export const uploadRuleImg = params => post(`/system/web/contest/saveRuleImg`, params)
export const addContestConfigData = params => post(`/system/web/banner/addContestConfigData`, params)

export const getContestBinding = params => post(`/system/web/contest/getContestBinding`, params)
export const contestBinding = params => post(`/system/web/contest/contestBinding`, params)

export const playerList = params => get('/system/web/basketballPlayer/playerList', params)
export const playerTeamList = params => get('/system/web/basketballPlayer/playerTeamList', params)
export const contestUpdate = params => post('/system/web/contest/update', params)
export const importPlayerApi = params => post('/system/web/basketballPlayer/importPlayer', params)
export const getLive = params => get('/system/web/live/tournament/beginLive', params)
export const gettournamentLive = params => get('/system/live/tournament/list', params)
export const giftBagList = params => get('/system/web/pack/list', params)
export const packSave = params => post('/system/web/pack/save', params)
export const packModify = params => post('/system/web/pack/modify', params)
export const packDelete = params => post(`/system/web/pack/delete/${params}`, params)
export const coachOrPlayerList = params => get('/system/web/bm/coachOrPlayerList', params)
export const coachOrPlayerAudit = params => post('/system/web/bm/coachOrPlayerAudit', params)

export const playerLogList = params => get('/system/web/playerLog/list', params)
export const playerLogSave = params => post('/system/web/playerLog/save', params)
export const playerLogModify = params => post('/system/web/playerLog/modify', params)
export const playerLogDelete = params => post('/system/web/playerLog/delete', params)
export const playerLogDownBox = params => get('/system/web/playerLog/downBox', params)
export const getTeamByTournamentId = params => get('/system/web/playerLog/getTeamByTournamentId', params)

// 新增或修改球队
export const saveOrUpdate = params => post(`/system/web/basketballPlayer/saveOrUpdate`, params)
